<template>
  <el-dialog
    :title="title"
    class="plat-icon-flowSubmitDialog"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    @close="closeDialog"
  >
    <div v-loading="flowLoading" class="plat-icon-Dialog">
      <div class="plat-icon-DialogContent">
        <div class="plat-icon-FlowSubmit">
          <h3>
            {{
              $_t(
                '选择签核流程 (下拉框中可能存在多个可选项目,请注意选择合适的流程)',
                'ChooseSignFlow'
              )
            }}
          </h3>
          <br />
          <div>
            <el-select v-model="selectednew_flowid" :disabled="isDisabled">
              <el-option
                v-for="flow in flowList"
                :key="flow.new_flowid"
                :value="flow.new_flowid"
                :label="flow.new_name"
              >
              </el-option>
            </el-select>
          </div>
          <br />
          <br />
          <div class="plat-icon-FlowSteps">
            <h3>
              {{ $_t('选择签核用户', 'ChooseSignUser') }}
            </h3>

            <div
              v-for="step in stepList"
              :key="step.new_name"
              class="plat-icon-FlowStep"
            >
              <br />
              <h4>
                {{ step.new_name }}
                <span v-if="step.new_approvalway == 1">
                  {{
                    $_t(
                      '(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)',
                      'ChooseSignUser_default'
                    )
                  }}
                </span>
              </h4>
              <br />
              <div
                v-if="
                  step.new_approvalway == 2 ||
                  step.new_approvalway == 3 ||
                  step.new_approvalway == 4
                "
                class="plat-icon-FlowStep-div"
              >
                <span
                  v-for="user in step.new_stepusers"
                  :key="user.systemuserid"
                >
                  {{ user.fullname }}
                </span>
              </div>
              <div v-else>
                <el-select v-model="step.ApproveUserId">
                  <el-option
                    v-for="user in step.new_stepusers"
                    :key="user.systemuserid"
                    :value="user.systemuserid"
                    :label="user.fullname"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="plat-icon-DialogFooter">
        <div class="plat-icon-DialogButtons">
          <el-button
            :loading="btnloading"
            :disabled="disabledSubmit"
            @click="submitFlow"
            >提交</el-button
          >
          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'RtFlowSubmit',
  props: {
    entityname: {
      type: String,
      required: true
    },
    id: {
      type:String,
      required: true
    },
    new_name: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: function () {
        return this.$_t('签核流程', 'Flow');
      }
    }
  },
  data() {
    return {
      selectednew_flowid: '',
      flowList: [],
      selectedUserId: [],
      stepList: [],
      btnloading: false,
      dialogVisible: false,
      disabledSubmit: true,
      flowLoading: true
    };
  },
  computed: {
    isDisabled() {
      return !rt.isNullOrWhiteSpace(this.new_name);
    }
  },
  watch: {
    selectednew_flowid(val) {
      console.log("进入1",val);
      if (val) {
        this.flowLoading = true;
        rt.get(
          'api/CrmFlow/GetFlowStepList?flowId=' +
            val +
            '&entityName=' +
            this.entityname +
            '&entityId=' +
            this.id
        )
          .then((res) => {
            for (var r in res) {
              res[r].ApproveUserId = res[r].new_stepusers[0].systemuserid;
            }
            this.stepList = res;
            this.disabledSubmit = false;
            this.flowLoading = false;
            console.log("进入stepList",this.stepList );
          })
          .catch((error) => {
            this.disabledSubmit = true;
            this.flowLoading = false;
            rt.showErrorToast(error);
          });
      } else {
        this.stepList = [];
      }
    },
    value(newVal, oldVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.show();
      }
    }
  },
mounted() {
  console.log("id:",this.id);
  console.log("id:",this.value);
},
  methods: {
    show() {
      this.getFlowList();
      this.dialogVisible = true;
    },
    getFlowList() {
      if (this.id) {
        rt.get(
          'api/CrmFlow/GetFlowList?entityName=' +
            this.entityname +
            '&entityid=' +
            this.id
        )
          .then((res) => {
            this.flowList = res;
            if (res == null || res.length <= 0) {
              return;
            }
            if (rt.isNullOrWhiteSpace(this.new_name)) {
              this.selectednew_flowid = res[0].new_flowid;
            } else {
              for (var i = 0; i < res.length; i++) {
                if (res[i].new_name == this.new_name) {
                  this.selectednew_flowid = res[i].new_flowid;
                  break;
                }
              }
            }
          })
          .catch((error) => {
            this.flowLoading = false;
            rt.showErrorToast(error);
          });
      }
    },
    submitFlow() {
      var approveList = [];
      this.stepList.map((step) => {
        let stepuser = step.new_stepusers.find(item=>item.systemuserid==step.ApproveUserId);
        approveList.push({
          StepId: step.new_flowstepsid,
          ApproveUserId: step.ApproveUserId,
          ApproveUserLogicalName:stepuser.LogicalName,
          ApproveUserName:stepuser.fullname
        });
      });

      var data = {
        EntityId: this.id,
        EntityTypeName: this.entityname,
        FlowId: this.selectednew_flowid,
        ApproveList: approveList
      };

      this.btnloading = true;
      rt.post('api/CrmFlow/submit', data)
        .then((res) => {
          rt.showSuccessToast(res);
          this.flowList = [];
          this.selectednew_flowid = '';
          this.dialogVisible = false;
          this.$emit('closesubmit');
          this.btnloading = false;
          setTimeout(() => {
          if (window.parent && window.parent !== window) {
            window.parent.location.reload();
            rt.hideLoadingToast();
          } 
          else {
            window.location.reload();
            rt.hideLoadingToast();
          }
        }, 500); 
        })
        .catch((error) => {
          this.btnloading = false;
          rt.showErrorToast(error);
        });
    },
    closeDialog() {
      this.flowList = [];
      this.selectednew_flowid = '';
      this.dialogVisible = false;
      this.$emit('input', this.dialogVisible);
    }
  }
};
</script>
<style lang="less" scoped>
.plat-icon-FlowStep {
  .plat-icon-FlowStep-div {
    padding: 0 4px;
    margin-top: 10px;
    font-size: inherit;
    line-height: 24px;
    color: #606266;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// flow-submit.vue?b5e1e536